import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStyles } from 'hooks'
import { Button } from 'reactstrap'
import { useCurrentContract, useBoolean } from 'hooks'
import { superFetch } from 'commons'
import { useGetContractValorisationStatus } from 'api'
import moment from 'moment'
import { addNotification } from 'notification'

export const ContractValorisation: React.FC = () => {
  const { t } = useTranslation()
  const ctr = useCurrentContract()
  const valorisationStatus = useGetContractValorisationStatus()

  const styles = useStyles((theme: any) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }))

  const callContractsValorisation = (contractIds: any) => {
    return superFetch({
      url: 'valorisations',
      method: 'POST',
      body: [Number(contractIds)],
    })
  }

  const handleClick = React.useCallback(() => {
    const fetchData = async () => {
      const result = window.confirm(t('contract.valorisation.confirmationMessage'))
      if (result) {
        try {
          await callContractsValorisation(ctr?.id)
          addNotification({
            type: 'success',
            title: '',
            message: t('contract.valorisation.successMessage'),
          })
        } catch (error) {
          addNotification({
            type: 'danger',
            title: '',
            message: t('contract.valorisation.failedMessage'),
          })
        }
      }
    }
    fetchData()
  }, [])

  return (
    <div css={styles}>
      <Button
        type="submit"
        css={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}
        onClick={handleClick}
      >
        {' '}
        {t('contract.valorisation.buttonTitle')}
      </Button>
      <div>
        {valorisationStatus?.DateLastValo && (
          <p>
            {t('contract.valorisation.dateOfLastValo')}:{' '}
            {moment(valorisationStatus.DateLastValo, 'YYYY-MM-DDTHH:mm:ss').format(
              'DD/MM/YYYY HH:mm',
            )}
          </p>
        )}
      </div>
      {valorisationStatus?.DemandeValo?.Id != null ? (
        <div>
          {valorisationStatus.DemandeValo.Statut != null && (
            <p>
              <strong>
                {t(`contract.valorisation.status.${valorisationStatus.DemandeValo.Statut}`)}
              </strong>
            </p>
          )}
          {valorisationStatus.DemandeValo.DateDemande && (
            <p>
              {t('contract.valorisation.dateDemandValo')}{' '}
              {moment(valorisationStatus.DemandeValo.DateDemande, 'YYYY-MM-DDTHH:mm:ss').format(
                'DD/MM/YYYY HH:mm',
              )}
            </p>
          )}
          {valorisationStatus.DemandeValo.Debut && (
            <p>
              {t('contract.valorisation.dateBeginValo')} :{' '}
              {moment(valorisationStatus.DemandeValo.Debut, 'YYYY-MM-DDTHH:mm:ss').format(
                'DD/MM/YYYY HH:mm',
              )}
            </p>
          )}
          {valorisationStatus.DemandeValo.Fin && (
            <p>
              {t('contract.valorisation.dateEndValo')} :{' '}
              {moment(valorisationStatus.DemandeValo.Fin, 'YYYY-MM-DDTHH:mm:ss').format(
                'DD/MM/YYYY HH:mm',
              )}
            </p>
          )}
        </div>
      ) : (
        <p>{t('contract.valorisation.noDemandValo')}</p>
      )}
    </div>
  )
}
